/**
 *
 * @export theme
 * @description The theme.
 *
 */
// TODO get colours from design system and refactor this file.
// TODO: Use better breakpoints(320px, 375px,768, 1024, 1200)
export const theme = {
  colors: {
    mainColor: '#fff',
    grey: '#f2f2f2',
    darkGrey: '#808284',
    textColor: '#646469',
    white: '#fff',
    lightGrey: '#ebebeb',
    dropdownLightGrey: '#f5f5f5',
    darkMainColor: '#e0b672',
    lightGreyBackground: '#FBFBFB',
    buttonHoverColor: '#ab7400',
    buttonHoverBorderColor: '#976600',
    facetDropdownHoverColor: '#337ab7',
    borderColor: '#ccc',
    searchInputColor: '#555555',
    facetDropdownBorderColor: '#66afe9',
    dropdownFilterColor: '#555',
    successColor: '#00B182',
  },
  mainColor: '#fff',
  textColor: '#646469',
  largeImageWidth: '250px',
  buttonColor: '#fff',
  buttonSize: '325px',
  buttonTextSize: '25px',

  breakpoints: ['480px', '768px', '1024px', '1200'],
  fontSizes: [12, 14, 16, 20, 24, 45],
}

const colorBuilder = ({ red, green, blue, alpha }) => `rgba(${red},${green}, ${blue}, ${alpha})`

/**
 *
 * @export themeMapper
 * @description Takes theme colors returned by GQL query(RBGA values) and turns them into hex values.
 * @param {*} { primary, secondary, primaryCta, soft }
 * @returns newTheme, the theme using hex values rather than rbgba.
 *
 */
export const themeMapper = ({ primary, secondary, primaryCta, soft, reasonsToHireMeCta }) => {
  const newTheme = {
    colors: {
      inverseColor: colorBuilder(primary),
      secondary: colorBuilder(secondary),
      primaryCta: colorBuilder(primaryCta),
      soft: colorBuilder(soft),
      reasonsToHireMeCta: colorBuilder(reasonsToHireMeCta),
    },
  }
  return newTheme
}
